export const BLUE_1 = "#3366EE";
export const BLUE_2 = "#1A62C2";
export const BLUE_3 = "#1A5099";
export const BLUE_4 = "#E5F5FF";
export const GRAY_1 = "#FFFFFF";
export const GRAY_2 = "#D9D9D9";
export const GRAY_3 = "#F1F1F1";
export const GRAY_4 = "#BBBBBB";
export const GRAY_5 = "#999999";
export const GRAY_6 = "#666666";
export const GRAY_7 = "#333333";
export const GREEN_1 = "#0BB000";
export const GREEN_2 = "#099000";
export const GREEN_3 = "#B0EBAD";
export const PINK_1 = "#FA6060";
export const PINK_2 = "#FA6060";
export const RED_1 = "#CC0000";
export const RED_2 = "#CC0000";
export const RED_3 = "#FFDDDD";
export const YELLOW_1 = "#E88C00";
export const YELLOW_2 = "#E88C11";
export const YELLOW_3 = "#5F3900";